"use client"

import FtpTable from "@/components/ftp/FtpTable";
import { FtpSchema } from "@/schemas/ftp.schema";
import { getFTPConnections } from "@/services/ftpConnections.service";
import { useEffect, useState } from "react";
import { z } from "zod";

export default function FTPPage(){
    const [ftpConnections, SetFtpConnection] = useState<z.infer<typeof FtpSchema>[]>([]);

    const fetchConnections = async () => {
        const connections = await getFTPConnections();
        SetFtpConnection(connections);
    }

    useEffect(() => {
        fetchConnections();
    }, []);

    return <FtpTable ftpConnections={ftpConnections} updateData={fetchConnections}></FtpTable>
}